import { render, staticRenderFns } from "./app-card-contacts.vue?vue&type=template&id=22cbf052&functional=true&"
import script from "./app-card-contacts.vue?vue&type=script&lang=js&"
export * from "./app-card-contacts.vue?vue&type=script&lang=js&"
import style0 from "./app-card-contacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports